import { DrawerMenuAppBar } from 'remote/global';
import { Typography } from '@mui/material';
import { RouteItemKey } from 'utils/data/routes';
import useMenuItems from 'utils/hooks/useMenuItems';
import { useUIDrawer } from 'api/queries/ui';

interface ComposedDrawerMenuAppBarProps
  extends Partial<React.ComponentProps<typeof DrawerMenuAppBar<RouteItemKey>>> {
  title?: string | null;
}

function ComposedDrawerMenuAppBar(props: ComposedDrawerMenuAppBarProps) {
  const { title, children, ...rest } = props;
  const menuItems = useMenuItems();
  const { isMobileDrawerOpen, setIsMobileDrawerOpen } = useUIDrawer();

  return (
    <DrawerMenuAppBar<RouteItemKey>
      menuItems={menuItems}
      isMobileDrawerOpen={isMobileDrawerOpen}
      setIsMobileDrawerOpen={setIsMobileDrawerOpen}
      {...rest}
    >
      {title != null && <Typography fontWeight={600}>{title}</Typography>}
      {children}
    </DrawerMenuAppBar>
  );
}

export default ComposedDrawerMenuAppBar;
